import { GPTGameIcon } from './types';

export const LuckyCardIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={30}
    viewBox="0 0 20 22"
    fill="none"
    style={{ isolation: 'isolate' }}
    {...props}>
    <defs>
      <linearGradient
        id="paint0_linear_17842_129549"
        x1={6.38865}
        y1={18.1086}
        x2={8.67888}
        y2={3.1099}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#DFDFDF" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_17842_129549"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.7 7.9) rotate(90) scale(9.86 1.62)">
        <stop stopColor="white" />
        <stop offset={0.0673077} stopColor="white" />
        <stop offset={0.153846} stopColor="white" />
        <stop offset={0.254808} stopColor="white" stopOpacity={0.872727} />
        <stop offset={0.370192} stopColor="#FFEEBA" stopOpacity={0.7} />
        <stop offset={0.514423} stopColor="#FFCC33" stopOpacity={0.6} />
        <stop offset={0.668269} stopColor="#F1B500" stopOpacity={0.4} />
        <stop offset={0.759615} stopColor="#F1B500" stopOpacity={0.3} />
        <stop offset={0.831731} stopColor="#F1B500" stopOpacity={0.2} />
        <stop offset={0.899038} stopColor="#F1B500" stopOpacity={0.1} />
        <stop offset={0.927885} stopColor="#F1B500" stopOpacity={0.05} />
        <stop offset={1} stopColor="#F1B500" stopOpacity={0} />
      </radialGradient>
    </defs>
    <path
      d="M12.9204 20.5073C12.5988 20.9753 12.3315 21.2588 12.154 21.2866C12.154 21.2866 12.1477 21.284 12.1358 21.2887C12.0316 21.301 11.877 21.2867 11.6843 21.2462C11.6738 21.2417 11.6658 21.2432 11.6544 21.2408C10.8033 21.0691 9.22061 20.4754 7.59733 19.7628C7.56391 19.7485 7.52839 19.7333 7.49705 19.7199C5.88093 19.008 4.23883 18.1835 3.25359 17.5514C2.76231 17.2323 2.43697 16.9643 2.35993 16.7805C2.34112 16.7379 2.33245 16.6773 2.33183 16.5979C2.29111 14.8226 6.37926 4.41693 7.27146 4.09442C8.09502 3.79937 10.5739 4.56928 12.966 5.55914L13.154 5.63967C15.6911 6.70648 18.0794 7.99387 18.2263 8.48205C18.4691 9.30055 14.7664 17.8539 12.9276 20.5079L12.9204 20.5073Z"
      fill="#CACFFB"
    />
    <path
      d="M11.9956 20.4543C11.7563 20.7647 11.5576 20.9515 11.4165 20.9751C11.3004 20.9922 11.1211 20.9722 10.8901 20.9228C10.1634 20.7722 8.9317 20.3288 7.59733 19.7672C7.5639 19.7529 7.52838 19.7377 7.49704 19.7242C5.26792 18.7869 2.78655 17.5437 1.92066 16.8119C1.76515 16.6785 1.65947 16.5615 1.62036 16.4681C1.31877 15.7407 3.41523 9.91621 5.00643 6.41446L5.00821 6.41028C5.67691 4.9413 6.25677 3.88176 6.53189 3.78202C7.439 3.45354 10.3667 4.42804 12.9659 5.56348L13.154 5.64401C15.3986 6.63749 17.3547 7.72743 17.4847 8.16876C17.7353 9.01531 13.7608 18.1569 11.9998 20.456L11.9956 20.4543Z"
      fill="#D5DAF1"
    />
    <path
      d="M7.6968 3.77882C7.6968 3.77882 13.1045 5.00697 17.4816 8.16226L18.2211 8.479C18.2211 8.479 18.0294 7.85296 15.5498 6.57097C14.0175 5.77875 11.1577 4.47238 7.69978 3.77762L7.6968 3.77882Z"
      fill="#D5DAF1"
    />
    <path
      d="M12.1564 21.2901C12.1564 21.2901 12.1502 21.2874 12.1382 21.2922C12.0884 21.2931 11.9499 21.2931 11.6867 21.2496C11.6763 21.2451 11.6682 21.2466 11.6569 21.2442C10.9803 21.1325 9.53289 20.7598 6.82711 19.5442C2.81919 17.7436 1.97206 16.8641 1.92102 16.8101C1.92102 16.8101 2.4305 17.1098 3.25394 17.554C4.40451 18.1753 6.16421 19.0773 8.00057 19.8292C8.1489 19.8927 8.29365 19.9473 8.43332 20.0021C9.15617 20.2944 9.75694 20.5196 10.2428 20.6955L10.2533 20.7C10.4935 20.7856 10.7045 20.8586 10.8925 20.9218C11.8129 21.232 12.1564 21.2901 12.1564 21.2901Z"
      fill="#898989"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.3}>
      <path
        d="M6.98427 4.37688C6.05054 4.47887 3.75202 11.2947 4.22358 13.9517C4.69724 16.6097 13.2886 15.0453 15.0083 13.3737C16.728 11.7022 16.6842 8.54847 15.8415 7.4681C14.9988 6.38773 7.99887 4.26501 6.98427 4.37688Z"
        fill="#F5F5F5"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'overlay'
      }}
      opacity={0.3}>
      <path
        d="M5.42727 18.629C3.74982 17.2579 12.8153 16.307 13.5512 16.3378C14.2871 16.3687 12.1589 20.5355 11.4622 20.8922C10.7655 21.249 5.42727 18.629 5.42727 18.629Z"
        fill="#F6F6F6"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.8}>
      <path
        d="M17.8312 8.31473C17.6453 8.2351 16.541 11.6388 14.7739 15.4534C13.0058 19.27 12.4959 19.964 12.6225 20.1937C12.7521 20.4223 15.1675 16.7222 16.3989 13.6968C17.6303 10.6714 18.2371 8.70616 18.1652 8.60859C18.0924 8.51312 17.8321 8.31264 17.8321 8.31264L17.8312 8.31473Z"
        fill="#DFDFDF"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.8}>
      <path
        d="M12.9202 20.5056C12.5986 20.9736 12.3313 21.2572 12.1537 21.285C12.1537 21.285 12.1474 21.2823 12.1355 21.2871C12.0314 21.2993 11.8768 21.285 11.684 21.2445C11.6735 21.24 11.6655 21.2415 11.6541 21.2391C10.9776 21.1274 9.53017 20.7547 6.8244 19.5391C2.81648 17.7385 1.96935 16.859 1.9183 16.805C1.7628 16.6716 1.65713 16.5546 1.61801 16.4612C1.31643 15.7338 3.41287 9.90931 5.00407 6.40756C4.38733 7.96307 1.93528 14.2484 1.89743 15.676C1.88825 15.9688 2.04709 16.2791 2.33156 16.5963C2.93245 17.2714 4.09198 17.9757 5.40399 18.6068C6.00538 18.8941 6.63958 19.1682 7.26304 19.4154C8.94779 20.0825 10.7918 20.3432 11.9034 20.4435C11.9351 20.4447 11.9649 20.45 11.9965 20.4512C12.5421 20.4994 12.8897 20.5074 12.9222 20.5065L12.9202 20.5056Z"
        fill="#FCFCFC"
      />
    </g>
    <path
      d="M14.2835 6.35961C13.1744 5.97612 13.5139 7.61973 14.2282 8.49183C14.9425 9.36394 16.4785 8.06364 16.7315 7.84812C16.9854 7.63051 14.9529 6.59191 14.2826 6.3617L14.2835 6.35961Z"
      fill="#F6F6F6"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.78}>
      <path
        d="M1.93613 17.1761C1.93613 17.1761 5.93894 18.831 9.39541 19.2761C13.1562 19.7607 13.3488 18.9509 13.8426 17.2377C14.1695 16.1059 15.3826 8.7181 15.4588 7.61699C15.535 6.51589 15.1685 6.35647 15.1685 6.35647L1.92786 16.7334L1.93613 17.1761Z"
        fill="#555555"
      />
    </g>
    <path
      d="M13.0904 17.7031C12.8962 18.2367 12.7085 18.5782 12.5435 18.6496C12.5435 18.6496 12.5368 18.6485 12.5264 18.6562C12.4287 18.6941 12.2754 18.719 12.0786 18.728C12.0674 18.7263 12.06 18.7298 12.0484 18.7303C11.1814 18.7772 9.50046 18.5987 7.75047 18.3154C7.71452 18.3099 7.67633 18.3041 7.64263 18.299C5.89972 18.0144 4.10349 17.6275 2.99135 17.2623C2.43579 17.0763 2.05372 16.8984 1.93311 16.7397C1.90421 16.7031 1.88065 16.6466 1.86017 16.57C1.37617 14.8614 2.72822 3.76352 3.51122 3.22786C4.23466 2.73597 6.82733 2.86058 9.39107 3.21986L9.59328 3.25074C12.3167 3.64821 14.9513 4.29649 15.2158 4.73232C15.6559 5.46393 14.213 14.672 13.0975 17.7019L13.0904 17.7031Z"
      fill="#BBBBBB"
    />
    <path
      d="M12.1803 17.8802C12.0264 18.2406 11.8808 18.4713 11.7504 18.5273C11.6423 18.5728 11.4637 18.5984 11.2277 18.6084C10.4864 18.6446 9.18295 18.5237 7.75046 18.3142C7.71452 18.3087 7.67632 18.3029 7.64262 18.2977C5.24978 17.9485 2.53616 17.3663 1.51459 16.8746C1.33064 16.7845 1.19904 16.6977 1.13779 16.6171C0.663634 15.9883 1.2347 9.82442 1.89827 6.03577L1.89896 6.03128C2.17847 4.44164 2.47452 3.27066 2.7159 3.1052C3.51409 2.56036 6.59033 2.7703 9.39107 3.21865L9.59327 3.24953C12.0152 3.64923 14.1819 4.21458 14.4182 4.60932C14.8728 5.36614 13.3143 15.2117 12.1851 17.8786L12.1803 17.8802Z"
      fill="url(#paint0_linear_17842_129549)"
    />
    <path
      d="M3.84264 2.81665C3.84264 2.81665 9.38555 2.65145 14.4133 4.61007L15.2087 4.73152C15.2087 4.73152 14.8663 4.17344 12.1446 3.55325C10.4628 3.16999 7.36699 2.6214 3.84523 2.81474L3.84264 2.81665Z"
      fill="#A8A8A8"
    />
    <path
      d="M12.5434 18.6457C12.5434 18.6457 12.5366 18.6446 12.5263 18.6522C12.4783 18.6656 12.3442 18.7003 12.0785 18.7241C12.0673 18.7224 12.0598 18.7259 12.0483 18.7264C11.3653 18.7876 9.87065 18.7893 6.94666 18.29C2.61554 17.5504 1.57515 16.9111 1.51221 16.8716C1.51221 16.8716 2.08052 17.0342 2.98896 17.258C4.25845 17.5714 6.18797 18.004 8.1541 18.272C8.31361 18.2964 8.46741 18.313 8.61637 18.3311C9.38938 18.433 10.0274 18.5006 10.5418 18.5492L10.5531 18.551C10.8071 18.5737 11.0297 18.5915 11.2275 18.6057C12.1963 18.6754 12.5434 18.6457 12.5434 18.6457Z"
      fill="#9B9B9B"
    />
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.3}>
      <path
        d="M3.30035 3.56668C2.42191 3.89925 1.90348 11.0735 3.0254 13.5278C4.14957 15.9824 12.0755 12.3164 13.3217 10.2674C14.568 8.21848 13.7359 5.17624 12.6495 4.34133C11.5631 3.50642 4.25461 3.2043 3.30035 3.56668Z"
        fill="#EFEFEF"
      />
    </g>
    <path
      d="M4.19063 8.05102L4.194 8.05154C5.39075 6.91977 7.34837 5.92494 8.7332 5.35115C8.7332 5.35115 12.2578 8.77434 12.3882 11.2053C12.3843 11.2082 12.391 11.2092 12.391 11.2092C12.4232 11.8368 12.2278 12.3916 11.6865 12.8105C9.05585 14.8372 7.67349 11.5889 7.8096 10.5615C7.8096 10.5615 6.41638 14.0675 4.00699 11.9042C2.86969 10.8796 3.11256 9.06254 4.18725 8.0505L4.19063 8.05102Z"
      fill="black"
    />
    <path
      d="M7.81289 10.5602C7.81289 10.5602 7.37709 14.4338 4.59122 15.2571L9.17843 15.9576C9.17843 15.9576 7.16279 14.1381 7.81289 10.5602Z"
      fill="black"
    />
    <g
      style={{
        mixBlendMode: 'overlay'
      }}
      opacity={0.3}>
      <path
        d="M8.72349 5.83854C8.19595 5.5781 4.9858 7.1185 4.39737 8.6614C3.80841 10.2077 6.88096 9.99884 7.70358 10.2524C8.52621 10.506 9.9566 12.5336 11.3106 12.0935C12.6647 11.6534 10.8784 6.9044 8.72401 5.83516L8.72349 5.83854Z"
        fill="#D5DAF1"
      />
    </g>
    <path
      d="M9.96126 7.07314C9.22374 6.66995 9.85966 8.2822 10.2801 8.36024C10.7006 8.43828 10.5742 7.40888 9.96126 7.07314Z"
      fill="#D5DAF1"
    />
    <g
      style={{
        mixBlendMode: 'overlay'
      }}
      opacity={0.3}>
      <path
        d="M5.36439 17.7585C3.39702 16.8512 11.9355 13.6604 12.6557 13.5059C13.3759 13.3515 12.3589 17.9185 11.7738 18.4383C11.1886 18.9582 5.36439 17.7585 5.36439 17.7585Z"
        fill="#D5DAF1"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.5}>
      <path
        d="M14.7904 4.66114C14.5905 4.63061 14.3738 8.20242 13.6182 12.338C12.8622 16.4757 12.5424 17.2753 12.7225 17.466C12.9052 17.6548 14.317 13.4677 14.7516 10.2304C15.1862 6.99302 15.2815 4.93844 15.1874 4.862C15.0933 4.78556 14.7908 4.65889 14.7908 4.65889L14.7904 4.66114Z"
        fill="#90847F"
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply'
      }}
      opacity={0.8}>
      <path
        d="M13.091 17.7029C12.8968 18.2366 12.7091 18.578 12.5441 18.6494C12.5441 18.6494 12.5374 18.6484 12.527 18.656C12.4293 18.6939 12.276 18.7188 12.0792 18.7279C12.068 18.7261 12.0606 18.7296 12.049 18.7301C11.366 18.7914 9.87139 18.7931 6.9474 18.2937C2.61628 17.5542 1.57589 16.9148 1.51295 16.8753C1.329 16.7852 1.19741 16.6984 1.13615 16.6178C0.661999 15.989 1.23305 9.82512 1.89663 6.03648C1.68907 7.69688 0.889153 14.396 1.21003 15.7876C1.27446 16.0733 1.50595 16.334 1.86078 16.5698C2.61159 17.073 3.91055 17.4644 5.3388 17.7469C5.99296 17.8744 6.67559 17.9809 7.3411 18.0641C9.13923 18.2881 10.9898 18.0787 12.0911 17.8974C12.122 17.8906 12.1522 17.8884 12.1832 17.8816C12.7234 17.7916 13.062 17.7123 13.0932 17.7033L13.091 17.7029Z"
        fill="#464646"
      />
    </g>
    <path
      d="M10.8641 3.65702C9.69443 3.56347 10.4346 5.06971 11.3446 5.73514C12.2546 6.40057 13.4159 4.75707 13.6069 4.48505C13.7982 4.21079 11.5704 3.71428 10.8638 3.65926L10.8641 3.65702Z"
      fill="#D5DAF1"
    />
    <g
      className="origin-[10.7px_7.9px] animate-[spin_3s_linear_infinite] will-change-transform"
      style={{
        mixBlendMode: 'screen'
      }}>
      <ellipse
        cx={10.7}
        cy={7.9}
        rx={1.62}
        ry={9.86}
        transform="rotate(135 10.7 7.9)"
        fill="url(#paint1_radial_17842_129549)"
      />
      <ellipse
        cx={10.7}
        cy={7.9}
        rx={1.62}
        ry={9.86}
        transform="rotate(-135 10.7 7.9)"
        fill="url(#paint1_radial_17842_129549)"
      />
    </g>
  </svg>
);
